import { Box, Link } from "@mui/material";
import { FC } from "react";

interface Props {
  image: any;
  type: string;
  title: string;
  link?: string;
}

const ThematicIndexesCarouselCard: FC<Props> = ({
  image,
  type,
  title,
  link = "#",
}) => {
  return (
    <Link href={link} target="_blank" sx={{ color: "#fff" }}>
      <Box
        sx={{
          position: "relative",
          height: "18rem",
          display: "flex",
          flexDirection: "column",
          margin: "0 14px",
          padding: "1.25rem",
          overflow: "hidden",
          background: `url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Box sx={{ fontSize: 11, fontWeight: 500, textTransform: "uppercase" }}>
          <span style={{ borderBottom: "1px solid #fff", paddingBottom: 4 }}>
            {type}
          </span>
        </Box>
        <Box
          sx={{
            maxWidth: "70%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontSize: 18,
            lineHeight: 1.2,
            fontWeight: 600,
            paddingBottom: "0.75rem",
          }}
        >
          {title}
        </Box>
        <Box sx={{ fontSize: 13, fontWeight: 700 }}>Learn More &gt;</Box>
      </Box>
    </Link>
  );
};

export default ThematicIndexesCarouselCard;
